import { render, staticRenderFns } from "./ServicesListCard.vue?vue&type=template&id=25ac3b20&"
import script from "./ServicesListCard.vue?vue&type=script&lang=js&"
export * from "./ServicesListCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports